module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_007.png
// module id = 2323
// module chunks = 5